import {
  createDirectus,
  readCollections as _readCollections,
  readCollection as _readCollection,
  readFieldsByCollection as _readFieldsByCollection,
  createItem as _createItem,
  readItem as _readItem,
  updateItem as _updateItem,
  deleteItem as _deleteItem,
  readItems as _readItems,
  readRelation as _readRelation,
  readRelations as _readRelations,
  readFile as _readFile,
  uploadFiles as _uploadFiles,
  readRelationByCollection as _readRelationByCollection,
  readMe as _readMe,
    customEndpoint as _customEndpoint,
  rest, authentication, refresh
} from '@directus/sdk'

let client;

export const useDirectus = () => {
  const init = () => {
    client = createDirectus(useRuntimeConfig().public.directusUrl).with(authentication('cookie', { credentials: 'include' })).with(rest({ credentials: 'include' }))
    console.log(`Connected to Directus : ${useRuntimeConfig().public.directusUrl}`)
  }

  const currentUser = async () => {
    return await client.request(_readMe({
      fields:['*', 'role.*']
    }))
  }

  const refresh = async () => {
    return client.refresh()
  }
  const login = async (email: string, password: string, otp?:string) => {
    if(otp)
    {
      return client.login(email, password, {otp:otp})
    }
    return client.login(email, password)
  }

  const readCollections = async () => {
    return await client.request(_readCollections())
  }

  const log = async (description) => {
    return await  client.request(_createItem('logs', {
      'description': description
    }))
  }

  const readCollection = async (collection: string) => {
    return await client.request(_readCollection(collection))
  }

  const readFieldsByCollection = async (collection: string) => {
    return await client.request(_readFieldsByCollection(collection))
  }

  const createItem = async (collection: string, data) => {
    return await client.request(_createItem(collection, data))
  }

  const readItem = async (collection: string, key: string, options) => {
    return await client.request(_readItem(collection, key, options))
  }

  const readItems = async (collection: string, params: {} = {}) => {
    return await client.request(_readItems(collection, params))
  }

  const updateItem = async (collection: string, key: string, data: any) => {
    return await client.request(_updateItem(collection, key, data))
  }

  const deleteItem = async (collection: string, key: string) => {
    return await client.request(_deleteItem(collection, key))
  }

  const readRelation = async (collection: string, field: string) => {
    return await client.request(_readRelation(collection, field))
  }

  const readRelations = async () => {
    return await client.request(_readRelations())
  }

  const customEndpoint = async (options) => {
    return await client.request(_customEndpoint(options))
  }


  const readRelationByCollection = async (collection: string) => {
    return await client.request(_readRelationByCollection(collection))
  }

  const uploadFiles = async (formData: FormData) => {
    return await client.request(_uploadFiles(formData))
  }
  const readFile = async (uuid: string) => {
    return await client.request(_readFile(uuid))
  }

  return {
    client,
    init,
    login,
    readCollections,
    readCollection,
    readFieldsByCollection,
    createItem,
    readItem,
    updateItem,
    readItems,
    deleteItem,
    readRelation,
    readRelationByCollection,
    readRelations,
    readFile,
    uploadFiles,
    currentUser,
    refresh,
    customEndpoint,
    log
  }
}
